<form>
    <app-input class="name"
               [formControl]="formGroup.controls.name"
               [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.nameLabel' | translate"
               [showErrors]="showErrors"
               [isDisabled]="readonly">
    </app-input>
    <app-textarea class="description"
                  [formControl]="formGroup.controls.description"
                  [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.descriptionLabel' | translate"
                  [showErrors]="showErrors"
                  [isDisabled]="readonly">
    </app-textarea>
    <app-input class="identifier"
               [formControl]="formGroup.controls.identifier"
               [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.identifierLabel' | translate"
               [showErrors]="showErrors"
               [isDisabled]="readonly">
    </app-input>
    <div class="assign">
        <app-assignation-dropdown class="operator"
                                  [selectedItem]="getSelectedItem()"
                                  [readonly]="readonly"
                                  [items]="roles">
        </app-assignation-dropdown>
        <app-input-switch class="switch"
                          [inline]="true"
                          [formControl]="formGroup.controls.requiresObservation"
                          [disabled]="readonly"
                          [tooltipText]="'admin.toolMaintenancePlans.tasks.createModal.requiresObservationTooltip' | translate"
                          onLabel="{{'admin.toolMaintenancePlans.tasks.createModal.requiresObservationLabel' | translate }}">
        </app-input-switch>
    </div>
    <div class="duration">
        <app-input class="value"
                   [formControl]="formGroup.controls.duration"
                   [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.durationLabel' | translate"
                   [showErrors]="showErrors"
                   [isDisabled]="readonly">
        </app-input>
        <app-dropdown class="unit"
                      [formControl]="formGroup.controls.unit"
                      [items]="units"
                      [showErrors]="showErrors"
                      [isDisabled]="readonly"
                      displayField="label"
                      valueField="id"
                      emptyText="{{ 'admin.toolMaintenancePlans.tasks.createModal.unit.placeholder' | translate }}">
        </app-dropdown>
    </div>
    <div class="instructions">
        <app-file-selector-input class="work"
                                 [path]="getFileName(formGroup.controls.workInstructions.value)"
                                 [fullPath]="getPathWithoutRoot(formGroup.controls.workInstructions.value)"
                                 [download]="readonly"
                                 placeholder="{{'admin.toolMaintenancePlans.tasks.createModal.instructionModal.button' | translate}}"
                                 (click)="clickWorkInstructions()">
        </app-file-selector-input>
        <app-photo-selector-input class="photos"
                                  [photos]="formGroup.controls.photo.value"
                                  [placeholder]="getPlaceholder()"
                                  [download]="readonly"
                                  (click)="openPhotoModal()">
        </app-photo-selector-input>
    </div>
    <div class="spare">
        <app-input-switch class="switch"
                          [formControl]="formGroup.controls.hasSpare"
                          [disabled]="readonly"
                          onLabel="{{'admin.toolMaintenancePlans.tasks.createModal.hasSpareLabel' | translate }}">
        </app-input-switch>
    </div>

    <div class="row-spare" *ngIf="formGroup.controls.hasSpare.value">
        <div class="mandatory-spare">
            <app-input-checkbox
                [formControl]="formGroup.controls.mandatorySpare">
                {{ 'admin.toolMaintenancePlans.tasks.createModal.mandatorySpare' | translate }}
            </app-input-checkbox>
        </div>
    </div>
    <div class="row-spare" *ngIf="formGroup.controls.hasSpare.value">
        <app-input class="form-input"
                   [formControl]="formGroup.controls.spareCode"
                   [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.spareCodeLabel' | translate"
                   [showErrors]="showErrors"
                   [isDisabled]="readonly">
        </app-input>
        <app-input class="form-input"
                   [formControl]="formGroup.controls.spareQuantity"
                   [placeholder]="'admin.toolMaintenancePlans.tasks.createModal.spareQuantityLabel' | translate"
                   [showErrors]="showErrors"
                   [isDisabled]="readonly">
        </app-input>
    </div>
    <div class="row" *ngIf="formGroup.controls.hasSpare.value">
        <div class="col s6 upload-wrapper">
            <app-file-selector-input
                [path]="getFileName(formGroup.controls.spareInstructions.value)"
                [fullPath]="getPathWithoutRoot(formGroup.controls.spareInstructions.value)"
                [download]="readonly"
                placeholder="{{'admin.toolMaintenancePlans.tasks.createModal.spareModal.button' | translate}}"
                (click)="clickSpareInstructions()">
            </app-file-selector-input>
        </div>
    </div>
    <details *ngIf="isEdit && task && task.maintenancePlans.length > 0 && !readonly" class="plans">
        <summary>{{ 'admin.toolMaintenancePlans.task.viewAssignedPlans' | translate }}</summary>
        <div *ngFor="let plan of task.maintenancePlans" class="plan-item">
            {{ plan.name }}
            <app-icon library="fontawesome" variant="fa-share" (click)="goToPlan(plan.id)"></app-icon>
        </div>
    </details>
</form>
<div class="buttons" *ngIf="!readonly">
    <app-button type="simple"
                (click)="onClose()">
        {{ 'generic.buttons.cancel' | translate }}
    </app-button>
    <div class="mutators">
        <app-button *ngIf="isEdit"
                    type="warning"
                    (click)="onCreate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
        <app-button *ngIf="!isEdit"
                    type="primary"
                    (click)="onCreate()">
            {{ 'admin.toolMaintenancePlans.tasks.createModal.create' | translate }}
        </app-button>
    </div>
</div>

<app-task-photo-upload-modal (confirmEvent)="onConfirmPhotoUpload($event)"
                             [readonly]="readonly">
</app-task-photo-upload-modal>

<app-task-instructions-tree-modal #workModal
                                  title="{{'admin.toolMaintenancePlans.tasks.createModal.instructionModal.title' | translate }}"
                                  [displayField]="'name'"
                                  [rootPath]="activity?.rootPath"
                                  [isLoading]="isLoadingFiles$ | async"
                                  type="WorkInstructions"
                                  (onUpdate)="updateInstructionDocument($event)">
</app-task-instructions-tree-modal>

<app-task-instructions-tree-modal #spareModal
                                  title="{{'admin.toolMaintenancePlans.tasks.createModal.spareModal.title' | translate }}"
                                  [displayField]="'name'"
                                  [rootPath]="activity?.rootPath"
                                  [isLoading]="isLoadingFiles$ | async"
                                  type="SpareInstructions"
                                  (onUpdate)="updateInstructionDocument($event)">
</app-task-instructions-tree-modal>
